var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231727",
    fillRule: "evenodd",
    d: "m8.307.76 7.005 6.966c.43.428.43 1.12 0 1.548l-7.005 6.967a1.105 1.105 0 0 1-1.557 0 1.09 1.09 0 0 1 0-1.548l5.127-5.098H2.059v-2.19h9.817L6.75 2.309a1.09 1.09 0 0 1 0-1.548 1.105 1.105 0 0 1 1.557 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#231727",
    fillRule: "evenodd",
    d: "M.363 8.5c0-.703.428-1.272.955-1.272h10.818c.528 0 .955.57.955 1.272s-.427 1.273-.955 1.273H1.318c-.527 0-.955-.57-.955-1.273",
    clipRule: "evenodd"
  })));
};
export default SvgArrow;